import { RaRecord, Identifier } from 'react-admin';

// Ensure LogEntry extends RaRecord to match React-Admin's requirements
export interface LogEntry extends RaRecord<Identifier> {
  timestamp: string;
  level: string;
  message: string;
  tenant: string;
  brand: string;
  environment: string;
}

// Use the LogEntry[] type directly in the mock logs
const MockLogs: LogEntry[] = [
  {
    id: '1',
    timestamp: '2024-10-17T14:32:00.123Z',
    level: 'info',
    message: 'Application started successfully',
    tenant: 'tenant-001',
    brand: 'brand-A',
    environment: 'production',
  },
  {
    id: '2',
    timestamp: '2024-10-17T14:35:01.567Z',
    level: 'error',
    message: 'Database connection failed',
    tenant: 'tenant-001',
    brand: 'brand-B',
    environment: 'production',
  },
  {
    id: '3',
    timestamp: '2024-10-17T14:40:22.789Z',
    level: 'debug',
    message: 'User session refreshed',
    tenant: 'tenant-002',
    brand: 'brand-C',
    environment: 'staging',
  },
];

export default MockLogs;